import { render, staticRenderFns } from "./TableTxItems.vue?vue&type=template&id=0f85611e&"
import script from "./TableTxItems.vue?vue&type=script&lang=js&"
export * from "./TableTxItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f85611e')) {
      api.createRecord('0f85611e', component.options)
    } else {
      api.reload('0f85611e', component.options)
    }
    module.hot.accept("./TableTxItems.vue?vue&type=template&id=0f85611e&", function () {
      api.rerender('0f85611e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableTxItems.vue"
export default component.exports